import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import globalES from "./translations/es/global.json";
import globalEN from "./translations/en/global.json";

i18next.use(initReactI18next).init({
  interpolation: { escapeValue: false },
  lng: "en",
  // Without this, i18next falls back to its default "dev" language, for which there is
  // no bundle -- so a key the active bundle lacks renders as the raw dotted key on
  // screen. Sixteen keys exist in en and not in es today, so that is not hypothetical.
  fallbackLng: "en",
  resources: {
    es: { global: globalES },
    en: { global: globalEN },
  },
});

export default i18next;
